import React, { Component } from 'react';
import ReactModal from 'react-modal';
import ClientModal from 'components/modals/ClientModal';
import ImportAccountsModal from 'components/modals/ImportAccountsModal';
import ImportGroupsModal from 'components/modals/ImportGroupsModal';
import MapAccountsModal from 'components/modals/MapAccountsModal';
import PeriodsModal from 'components/modals/PeriodsModal';
import JournalEntryModal from 'components/modals/JournalEntryModal';
import ConsolidationsModal from 'components/modals/ConsolidationsModal';
import SubsidiaryModal from 'components/modals/SubsidiaryModal';
import KpiEntryModal from 'components/modals/KpiEntryModal';
import HelpModal from 'components/modals/HelpModal';
import AboutModal from 'components/modals/AboutModal';
import ExchangeRatesModal from 'components/modals/ExchangeRatesModal';

const modalComponentLookupTable = {
  ClientModal,
  ImportAccountsModal,
  ImportGroupsModal,
  MapAccountsModal,
  PeriodsModal,
  JournalEntryModal,
  ConsolidationsModal,
  SubsidiaryModal,
  KpiEntryModal,
  HelpModal,
  AboutModal,
  ExchangeRatesModal,
};

export default class Modal extends Component {
  onClose() {
    if (this.props.item.onClose) {
      this.props.item.onClose();
    }
    this.props.onClose(this.props.item);
  }
  onConfirm() {
    if (this.props.item.onConfirm) {
      this.props.item.onConfirm();
      this.props.onClose(this.props.item);
    }
  }
  render() {
    const { type, data } = this.props.item;
    if (type === 'confirmation') {
      const { text } = this.props.item;
      return (
        <ReactModal
          isOpen={true}
          contentLabel="Confirmation"
          onRequestClose={() => this.onClose()}
          className="modal ConfirmationModal"
          overlayClassName="overlay"
        >
          <h2>Confirmation</h2>
          <div className="text">{text}</div>
          <div className="buttons">
            <button className="btn" onClick={() => this.onConfirm()}>
              Confirm
            </button>
            <button className="btn" onClick={() => this.onClose()}>
              Close
            </button>
          </div>
        </ReactModal>
      );
    } else if (type === 'component') {
      const { componentType } = this.props.item;
      const ModalComponent = modalComponentLookupTable[componentType];
      return (
        <ReactModal
          isOpen={true}
          contentLabel="Modal"
          onRequestClose={() => this.onClose()}
          className="modal"
          overlayClassName="overlay"
        >
          <button className="close btn" onClick={() => this.onClose()}>
            &times;
          </button>
          {ModalComponent !== undefined ? (
            <ModalComponent data={data} onClose={() => this.onClose()} />
          ) : (
            <p>{`There is no modal component ${componentType} in modalComponentLookupTable in Modal.jsx. Add it.`}</p>
          )}
        </ReactModal>
      );
    }
    return <div></div>;
  }
}
